import { render, staticRenderFns } from "./MyPackage.vue?vue&type=template&id=47fee82c&scoped=true"
import script from "./MyPackage.vue?vue&type=script&lang=js"
export * from "./MyPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fee82c",
  null
  
)

export default component.exports